import { signOut } from "next-auth/react";
import { useQueryClient } from "@tanstack/react-query";
import { useStore } from "@store/index";
import { invalidateProfileQueries } from "@store/helpers/profile/invalidateProfileQueries";

const useSignOut = () => {
    const clearWishlist = useStore((state) => state.clearWishlist);
    const setIsLoggedIn = useStore((state) => state.setIsLoggedIn);
    const clearMe = useStore((state) => state.clearMe);
    const queryClient = useQueryClient();

    async function signOutHandler(redirectTo: string = "") {
        clearWishlist();
        clearMe();
        setIsLoggedIn(false);
        const redirectConfig = redirectTo ? { callbackUrl: redirectTo } : { redirect: false };
        await signOut(redirectConfig);

        invalidateProfileQueries(queryClient);
    }

    return { signOut: signOutHandler };
};

export default useSignOut;
